import { useSelector } from 'react-redux';
import { entitiesSelector } from '../services/selectors';
/**
 * @category React Hook
 */

export function useAuthenticated() {
  const {
    flowType
  } = useSelector(entitiesSelector);
  return flowType;
}